import { render, staticRenderFns } from "./TenancyTenancy.vue?vue&type=template&id=273fb354&scoped=true&"
import script from "./TenancyTenancy.vue?vue&type=script&lang=js&"
export * from "./TenancyTenancy.vue?vue&type=script&lang=js&"
import style0 from "./TenancyTenancy.vue?vue&type=style&index=0&id=273fb354&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273fb354",
  null
  
)

export default component.exports